import e from "react";
import i from "@appchoose/cn";
import * as r from "@radix-ui/react-dropdown-menu";
const s = e.createContext(
  {}
), c = () => {
  const t = e.useContext(s);
  return {
    value: t.value,
    onValueChange: t.onValueChange
  };
}, p = ({ className: t, onValueChange: n, value: o, ...a }) => {
  const d = e.useMemo(
    () => ({ value: o, onValueChange: n }),
    [o, n]
  );
  return /* @__PURE__ */ e.createElement(s.Provider, { value: d }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: i(
        "relative flex items-center divide-x divide-white",
        t
      )
    },
    /* @__PURE__ */ e.createElement(r.Root, { ...a })
  ));
};
p.displayName = "ButtonDropdown";
const l = e.forwardRef(({ className: t, type: n, ...o }, a) => /* @__PURE__ */ e.createElement(
  "button",
  {
    type: n,
    className: i(
      "inline-flex cursor-pointer items-center rounded-l-lg border-gray-900 bg-gray-900 p-3 py-2.5 text-sm font-bold text-white outline-none transition-colors duration-300 hover:bg-gray-700 focus-visible:ring-2 focus-visible:ring-gray-900/30 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300",
      t
    ),
    ref: a,
    ...o
  }
));
l.displayName = "ButtonDropdownButton";
const g = e.forwardRef(({ className: t, type: n, ...o }, a) => /* @__PURE__ */ e.createElement(
  r.Trigger,
  {
    type: n,
    className: i(
      "inline-flex cursor-pointer items-center rounded-r-lg border-gray-900 bg-gray-900 p-3 text-sm font-bold text-white outline-none transition-colors duration-300 hover:bg-gray-700 focus-visible:ring-2 focus-visible:ring-gray-900/30 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300",
      t
    ),
    ref: a,
    ...o
  }
));
g.displayName = r.Trigger.displayName;
l.displayName = "ButtonDropdownButton";
const b = e.forwardRef(({ className: t, align: n = "end", sideOffset: o = 4, ...a }, d) => /* @__PURE__ */ e.createElement(r.Portal, null, /* @__PURE__ */ e.createElement(
  r.Content,
  {
    ref: d,
    align: n,
    sideOffset: o,
    className: i(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-gray-900 py-2 text-white shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...a
  }
)));
b.displayName = r.Content.displayName;
const f = e.forwardRef(({ className: t, inset: n, value: o, ...a }, d) => {
  const { value: u, onValueChange: m } = c();
  return /* @__PURE__ */ e.createElement(
    r.Item,
    {
      ref: d,
      className: i(
        "relative flex cursor-pointer select-none items-center px-3 py-1.5 text-sm outline-none transition-colors focus:bg-gray-700 data-[disabled]:pointer-events-none data-[state=selected]:font-bold data-[disabled]:opacity-50",
        n && "pl-8",
        t
      ),
      "data-state": u === o ? "selected" : void 0,
      onClick: () => m(o),
      ...a
    }
  );
});
f.displayName = r.Item.displayName;
export {
  p as ButtonDropdown,
  l as ButtonDropdownButton,
  b as ButtonDropdownMenuContent,
  f as ButtonDropdownMenuItem,
  g as ButtonDropdownMenuTrigger
};
